/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo
 */
export interface FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo {
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo
     */
    EmailName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo
     */
    MailToLink: string;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo(value: object): value is FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo {
    if (!('EmailName' in value) || value['EmailName'] === undefined) return false;
    if (!('MailToLink' in value) || value['MailToLink'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo {
    return FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'EmailName': json['EmailName'],
        'MailToLink': json['MailToLink'],
    };
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo {
    return FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfoToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsEmailInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'EmailName': value['EmailName'],
        'MailToLink': value['MailToLink'],
    };
}

